$ ->

  $(document).ready () ->
    if window.location.hash
      $.smoothScroll
        scrollTarget: window.location.hash + ""
        offset: -150

  $('body').smoothScroll
    delegateSelector: '[data-scroll]'
    offset: -150
    speed: 1000
    
  $(window).resize () ->
    if $(window).outerWidth() < 992
      $.smoothScroll 'options', {offset: -80}
    else
      $.smoothScroll 'options', {offset: -150}
      
  $(window).trigger('resize')

  $("#header").headroom
    "offset": 50
    "tolerance": 10
    "classes": 
      "initial": "animated"
      "pinned": "slideDown"
      "unpinned": "slideUp"
    onTop: () ->
      $('#header .hotline-btn').addClass('btn-outline-primary').removeClass('btn-primary')
    onNotTop: () ->
      $('#header .hotline-btn').addClass('btn-primary').removeClass('btn-outline-primary')
